// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__pR403","productName":"Table_productName__2_UoG"};